import React, { useEffect, useState } from 'react';
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import InfoContent from 'components/commercetools-ui/atoms/info-section-with-image';
import SectionWithBanner from 'components/commercetools-ui/atoms/section-with-banner';
import ImageTextContent from 'components/commercetools-ui/atoms/image-text-content';
import TimelineComponent from 'components/commercetools-ui/atoms/timeline';
import Typography from 'components/commercetools-ui/atoms/typography';
import WhiteOverlay from 'components/commercetools-ui/atoms/overlay/white-overlay';

interface OurStoryProps {
  data: any;
}
type componentType = {
  section_with_image_text: any;
  section_with_banner: any;
  multiple_info_section: any;
  section_with_heading_description: any;
};
const OurStoryPage: React.FC<OurStoryProps> = ({ data }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the timeout duration as needed
  }, []);

  return (
  <>
    {loading && <WhiteOverlay />}
    <div className=" w-full">
    <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
        <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>
          <span className="text-14 font-normal leading-4 text-[#666]">About Us</span>
        </Breadcrumb>
      </div>
      <div className="flex flex-col gap-y-48 md:gap-y-50">
          {data?.sections?.map((component: componentType, index: number) => (
          
          <div key={index}>
            {component?.section_with_banner && (
              <div>
                  <SectionWithBanner data={component?.section_with_banner} />
              </div>
            )}
            {component?.section_with_image_text && (
              <div className="xl:px-80 3xl:px-180">
                <InfoContent
                  data={component?.section_with_image_text}
                  index={index}
                  totalSections={data?.components?.length}
                />
              </div>
            )}

          </div>
        ))}
        <div className="lg:flex items-center pb-48 -mt-48">
          <div className="px-24 xl:pl-90 2xl:pl-180">
            <Typography
              as="h1"
              className="text-28 text-center lg:text-left font-semibold leading-[3rem] text-primary-black drop-shadow-sm max-w-[40rem] 3xl:text-40"
            >
              {data?.sections?.[3]?.section_with_heading_description?.title}
            </Typography>
          </div>
          <div className="lg:w-[45rem] lg:h-[15rem] 3xl:h-[20rem] flex-1 lg:px-48 xl:px-90">
            <TimelineComponent data={data?.sections?.[4]?.multiple_info_section} />
          </div>
        </div>
      </div>
      </div>
      </>
  );
};
export default OurStoryPage;
